/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./fortify-redirect.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./fortify-redirect.component";
import * as i3 from "../../../services/shared/shared.service";
import * as i4 from "../../../services/storage/storage.service";
import * as i5 from "@ngrx/store";
import * as i6 from "@angular/router";
var styles_FortifyRedirectComponent = [i0.styles];
var RenderType_FortifyRedirectComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_FortifyRedirectComponent, data: {} });
export { RenderType_FortifyRedirectComponent as RenderType_FortifyRedirectComponent };
export function View_FortifyRedirectComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_FortifyRedirectComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-fortify-redirect", [], null, null, null, View_FortifyRedirectComponent_0, RenderType_FortifyRedirectComponent)), i1.ɵdid(1, 114688, null, 0, i2.FortifyRedirectComponent, [i3.SharedService, i4.StorageService, i5.Store, i6.ActivatedRoute], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var FortifyRedirectComponentNgFactory = i1.ɵccf("app-fortify-redirect", i2.FortifyRedirectComponent, View_FortifyRedirectComponent_Host_0, {}, {}, []);
export { FortifyRedirectComponentNgFactory as FortifyRedirectComponentNgFactory };
